/** Figma `73:1092` — Signal Provider View Details modal tokens (scaled up for readability). */

export const SP_DETAIL_MODAL_WIDTH_PX = 640
export const SP_DETAIL_MODAL_BORDER = '#e2e8f0'
export const SP_DETAIL_MODAL_RADIUS_PX = 12
export const SP_DETAIL_PADDING_X_PX = 20

export const SP_DETAIL_AVATAR_SIZE_PX = 40
export const SP_DETAIL_AVATAR_BG = '#008cd0'

export const SP_DETAIL_STAT_TILE_HEIGHT_PX = 64
export const SP_DETAIL_STAT_TILE_GAP_PX = 12
export const SP_DETAIL_STAT_TILE_RADIUS_PX = 10

export const SP_DETAIL_STAT_TILES = [
  {
    key: 'instruments',
    label: 'Instruments',
    bg: '#e7fbff',
    border: '#c7ebf9',
  },
  {
    key: 'earnings',
    label: 'Earnings',
    bg: '#d1fae5',
    border: '#b2ffd8',
  },
  {
    key: 'redeemed',
    label: 'Redeemed',
    bg: '#ffebee',
    border: '#ffd9ea',
  },
  {
    key: 'available',
    label: 'Available',
    bg: 'rgba(245, 158, 11, 0.2)',
    border: '#fbe797',
  },
] as const

export const SP_DETAIL_DEMO_PANEL_BG = '#eef9ff'
export const SP_DETAIL_DEMO_PANEL_BORDER = '#e1e7f3'
export const SP_DETAIL_DEMO_PANEL_RADIUS_PX = 10
